import { render, staticRenderFns } from "./GlobalSavingOverlay.vue?vue&type=template&id=067fcfc6&scoped=true"
import script from "./GlobalSavingOverlay.vue?vue&type=script&lang=js"
export * from "./GlobalSavingOverlay.vue?vue&type=script&lang=js"
import style0 from "./GlobalSavingOverlay.vue?vue&type=style&index=0&id=067fcfc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067fcfc6",
  null
  
)

export default component.exports